import {css} from '@emotion/react'
import ConditionalDownloadCTA from './ConditionalDownloadCTA'

const translations = {
    en: {
        title: 'Privacy by Design.',
        subtitle: 'Private AI, without the tracking or logging.',
        bottomText: 'Free to download and use. Subscribe for unlimited access to all features.',
    },
    fr: {
        title: 'Confidentialité dès la conception.',
        subtitle: 'IA privée, sans suivi ni journalisation.',
        bottomText:
            'Gratuit à télécharger et à utiliser. Abonnez-vous pour un accès illimité à toutes les fonctionnalités.',
    },
    de: {
        title: 'Datenschutz durch Design.',
        subtitle: 'Private KI, ohne Tracking oder Protokollierung.',
        bottomText:
            'Kostenlos zum Download und zur Nutzung. Abonnieren Sie für unbegrenzten Zugang zu allen Funktionen.',
    },
    nl: {
        // "Privacy by Design" is a fixed industry term (named in the GDPR) and
        // stays in English, same as "Anonymous View".
        title: 'Privacy by Design.',
        subtitle: 'Private AI, zonder tracking of logging.',
        bottomText: 'Gratis te downloaden en te gebruiken. Abonneer voor onbeperkte toegang tot alle functies.',
    },
}

const Section3 = ({languageCode = 'en', experimentId, os, browser, isMobileDevice}) => {
    const text = translations[languageCode] || translations.en

    return (
        <section
            className="vanish-section4"
            css={css`
                width: 100%;
                background: #000;
                display: flex;
                flex-direction: column;
                justify-content: center;
                align-items: center;
                padding: 104px 35px;
                box-sizing: border-box;
                background: var(--background-teritary, #100026);
                position: relative;
                @media (max-width: 480px) {
                    padding: 72px 20px;
                }
            `}
        >
            <div
                css={css`
                    border-radius: 781px;
                    background: rgba(85, 11, 200, 0.8);
                    filter: blur(225px);
                    position: absolute;
                    width: 781px;
                    height: 779px;
                    z-index: 1;
                    top: 0;
                    @media (max-width: 480px) {
                        top: 100px;
                        background: rgba(85, 11, 200, 0.5);
                        filter: blur(125px);
                    }
                `}
            />
            <div
                className="content-wrapper"
                css={css`
                    display: flex;
                    flex-direction: column;
                    align-items: center;
                    text-align: center;
                    gap: 40px;
                    width: 100%;
                    z-index: 2;
                    @media (max-width: 480px) {
                        gap: 32px;
                    }
                `}
            >
                <h2
                    css={css`
                        color: var(--text-primary, #f2f3fb);
                        text-align: center;
                        leading-trim: both;
                        text-edge: cap;
                        font-family: Inter;
                        font-size: 60px;
                        font-style: normal;
                        font-weight: 700;
                        line-height: normal;
                        letter-spacing: 0.5px;
                        @media (max-width: 480px) {
                            font-size: 42px;
                            line-height: 50px; /* 119.048% */
                        }
                    `}
                >
                    {text.title}
                </h2>

                <p
                    css={css`
                        color: var(--text-primary, #ebecf7);
                        text-align: center;
                        leading-trim: both;
                        text-edge: cap;
                        font-family: Inter;
                        font-size: 18px;
                        font-style: normal;
                        font-weight: 400;
                        line-height: 18px;
                        @media (max-width: 480px) {
                            font-size: 16px;
                            line-height: 24px; /* 150% */
                        }
                    `}
                >
                    {text.subtitle}
                </p>

                <ConditionalDownloadCTA
                    isMobileDevice={isMobileDevice}
                    languageCode={languageCode}
                    experimentId={experimentId}
                    os={os}
                    browser={browser}
                    ctaType="cta-bottom"
                    downloadBadgeOverrideStyles={css`
                        h2.download-cta {
                            color: var(--text-tertiary, #0fe);
                        }
                    `}
                    desktopWrapperStyles={css`
                        margin-top: 16px;
                    `}
                />
                <p
                    css={css`
                        color: var(--text-secondary, #b4a8e1);
                        text-align: center;
                        leading-trim: both;
                        text-edge: cap;
                        font-family: Inter;
                        font-size: 16px;
                        font-style: normal;
                        font-weight: 400;
                        line-height: 24px; /* 150% */
                    `}
                >
                    {text.bottomText}
                </p>
            </div>
        </section>
    )
}

export default Section3
